
























import { Blog } from '@/resource/blog/blog.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import truncateString from '@/utils/common/truncate';
import generateBLogUrl from '@/utils/common/generate-blog-url';

@Component({
  components: {},
})
export default class BlogContainer extends Vue {
  @Prop({ required: true })
  blog: Blog;

  @Prop({ default: false })
  isColumn: boolean;

  @Prop({ default: 200 })
  imageHeight: number;

  @Prop({ default: false })
  isSmall: boolean;

  get parentClass() {
    return this.isColumn
      ? 'w-full'
      : 'sm:flex w-full items-stretch justify-between';
  }

  get imageClass() {
    return this.isColumn
      ? `bg-cover bg-no-repeat bg-center w-full h-180 sm:h-${this.imageHeight} rounded mb-16`
      : `bg-cover bg-no-repeat bg-center sm:w-40% h-180 sm:h-${this.imageHeight} rounded mb-10 sm:`;
  }

  get textClass() {
    return this.isColumn ? 'w-full' : 'sm:w-60% sm:pl-20';
  }

  get titleClass() {
    return this.isSmall
      ? 'text-16 sm:text-14 font-bold mb-4 sm:mb-10'
      : 'text-16 sm:text-18 font-bold mb-4 sm:mb-10';
  }

  get description() {
    return this.isSmall ? null : truncateString(this.blog.description, 100);
  }

  get detail() {
    const date = this.$dayjs(this.blog.createdAt);

    return `${date.format('D MMM YYYY')}, ${this.blog.duration} minutes read`;
  }

  get blogUrl() {
    return generateBLogUrl(this.blog);
  }
}
